import "./style.scss";
import React, { useEffect, useRef, useState } from "react";
import useCards from "../../../pctHooks/useCards";
import { Label, Text, PinPct } from "../../atoms";
import { BsLockFill } from "react-icons/bs";
import { FaCheck } from "react-icons/fa6";
import { getContentTypeIco, getContentTypeLabel } from "../../../services/utils";
import useContentNavigationBtn from "pctHooks/useContentNavigationBtn";
import {
    buildNavigationCollection,
    getCurrentIcon,
    getEnrollmentObject,
    getEvaluationProgressTexts,
    getIsCurrentContent,
    getProgressLabel,
} from "./utils";

import { ReactSVG } from 'react-svg';

import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";

type Props = {
    collection: any;
    nodeCodeCurrent?: any;
    contentCollection: any;
    nodeEnrollment?: any;
    prevItem: any;
    expandButton?: any;
    onClick?: any;
    closeMap?: any;
    isCurrentChild?: any;
    forceCurrentComplete?: any;
};

const useTooltipStyles = makeStyles(() => ({
    tooltip: {
        fontSize: "10px !important",
        padding: "4px 10px",
        lineHeight: 1,
        maxWidth: "160px",
        textAlign: "center",
    },
    arrow: {
        fontSize: "8px",
    },
}));

const CardBlockMap = ({
    collection,
    nodeCodeCurrent,
    onClick,
    contentCollection,
    prevItem,
    expandButton = null,
    nodeEnrollment,
    closeMap,
    isCurrentChild,
}: Props) => {
    const tooltipClasses = useTooltipStyles();
    const setProgressStateRef = useRef(null as any);
    const progressInfoRef = useRef(null as any);
    const isExpanded = useRef(false);
    const [currentCollection, setCurrentCollection] = useState(collection);

    const {
        contentEnrollment,
        elementType,
        hasChildren,
        idContentType,
        label,
        mandatory,
        nodeCode,
        questionnaire,
        title,
    } = currentCollection;

    const enrollmentObject = getEnrollmentObject(currentCollection, nodeEnrollment);
    const currentIco = getCurrentIcon(collection, idContentType);
    const isCurrentContent = getIsCurrentContent({
        contentCollection,
        contentEnrollment,
        elementType,
        nodeCode,
        nodeCodeCurrent,
        questionnaire,
    });

    const currentCollectionToCard = buildNavigationCollection({
        currentCollection,
        enrollmentObject,
        nodeEnrollment,
        questionnaire,
    });

    const { callNodeEnrollment, initialProgressState, modalLoadingNodeEnrollment } = useCards({
        id: enrollmentObject ? enrollmentObject.idEnrollment : null,
        collection: currentCollectionToCard,
        dataParent: currentCollectionToCard,
        setProgressStateRef,
        progressInfoRef,
    });

    const currentNavigationCollection = contentCollection.currentContentCollection || contentCollection;

    const { handMouseNextPrevEvent, hasNextSequential } = useContentNavigationBtn({
        collection: currentNavigationCollection,
        navigationTarget: currentCollectionToCard,
        targetItem: currentCollection,
        parentNodeEnrollment: nodeEnrollment,
        prevItem,
    });

    const prerequisites = hasNextSequential();
    const progress = initialProgressState();
    const hasPerfectGrade =
        questionnaire?.grade !== null && questionnaire?.grade !== undefined && Number(questionnaire.grade) === 100;
    const evaluationProgressTexts = getEvaluationProgressTexts({
        collection,
        hasPerfectGrade,
        progress,
        progressStatus: getProgressLabel(collection, progress),
        questionnaire,
    });
    const { concluidedText, progressStatus } = evaluationProgressTexts;
    const itemClass = `cardBlockMap ${prerequisites ? "disabledCard" : ""}`;

    const _onFinishedNodeEnrollment = (enrollmentResult, e, openNode) => {
        let tempObj = currentCollection;
        tempObj.nodeEnrollment = {
            idNodeEnrollment: enrollmentResult.data.newId,
            idEnrollment: nodeEnrollment.idEnrollment,
            idTeam: nodeEnrollment.idTeam,
            idUser: nodeEnrollment.idUser,
        };

        setCurrentCollection(tempObj);

        if (openNode) {
            handMouseNextPrevEvent(e);
        }

        onClick(enrollmentResult);
    };

    useEffect(() => {
        if (!isCurrentChild || isExpanded.current || !onClick) {
            return;
        }

        isExpanded.current = true;
        onClick(true);
    }, [isCurrentChild, onClick]);

    const createNodeEnrollment = (e, openNode = false) => {
        const dataParent = {
            node: {
                nodeEnrollment: nodeEnrollment,
            },
        };

        const collectionToNodeEnrollment = {
            data: {
                nodeEnrollment: { enrollment: nodeEnrollment },
                nodeCode: currentCollection.nodeCode,
            },
        };
        callNodeEnrollment({
            collection: collectionToNodeEnrollment,
            modalLoadingNodeEnrollment: modalLoadingNodeEnrollment,
            _parent: dataParent,
            _onFinished: (enrollmentResult) => _onFinishedNodeEnrollment(enrollmentResult, e, openNode),
            doestGoToLevelPage: true,
        });
    };

    const expandEvent = (e) => {
        if (!currentCollection.nodeEnrollment) {
            createNodeEnrollment(e, false);
        } else {
            onClick();
        }

        e.stopPropagation();
    };

    const openNodeEvent = (e) => {
        if (!nodeCode || currentCollection.nodeEnrollment) {
            handMouseNextPrevEvent(e);
        } else {
            createNodeEnrollment(e, true);
        }

        if (closeMap) {
            closeMap(e);
        }
        e.stopPropagation();
    };

    return (
        <div className={itemClass}>
            {expandButton && hasChildren?.toString() !== '0' ? expandButton(expandEvent) : <></>}
            <PinPct text={'Você está aqui!'} className={`pin ${isCurrentContent ? 'current' : ''}`} />
            <div className="baseInfos" onClick={openNodeEvent}>
                {collection.elementType === 'NODE' ? (
                    <Label text={label} />
                ) : (
                    <Tooltip
                        title={getContentTypeLabel(currentIco)}
                        aria-label={getContentTypeLabel(currentIco)}
                        placement="top"
                        classes={tooltipClasses}
                        // disableHoverListener={inactiveTooltip}
                    >
                        <div className={`currentIcoBase currentIco${currentIco}`}>
                            <ReactSVG
                                beforeInjection={(svg) => {
                                    // svg.setAttribute(
                                    //     "style",
                                    //     `width: 20px; height: 20px; margin-bottom: 5px; fill: ${
                                    //     getColors("menuItem")?.color || "white"
                                    //     }`
                                    // );
                                }}
                                src={getContentTypeIco(currentIco)}
                                alt="img"
                            />
                            {/* {getContentTypeIco(currentIco)} */}
                        </div>
                    </Tooltip>
                )}

                <div className={`infosContainer`}>
                    <div className="headerInfos">{title && <Text component="small" text={title} />}</div>

                    <div className="footerInfos">
                        {concluidedText && <Text className="concluidedText" component="small" text={concluidedText} />}
                        {prerequisites && (
                            <div className="lockBlock">
                                <BsLockFill className="lock" />
                                <Text
                                    component="small"
                                    text={'<span>Sequência obrigatória.</span> Conclua a etapa anterior para continuar'}
                                />
                            </div>
                        )}
                    </div>
                </div>

                <div className="rightInfos">
                    {!mandatory ? <Label text={'OPCIONAL'} /> : <></>}
                    <div className="progressInfos">
                        {!prerequisites ? (
                            <>
                                {/* {hasPerfectGrade && <FaCheck className="perfectGradeCheck" aria-label="Nota máxima" />} */}
                                <Text
                                    component="small"
                                    text={`${
                                        hasPerfectGrade
                                            ? `<span class="passedStatus">Nota: ${progressStatus}</span>`
                                            : progressStatus
                                    }`}
                                />
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};


export default CardBlockMap;
